// src/ConsumerApp/api/search/search.service.js
import { apiClient } from '../apiClient';

export const SearchService = {
  /**
   * Global multi-entity search (products, categories, subcategories)[cite: 39, 40]
   */
  globalSearch: async ({ search, page = 1, pageSize = 20 }) => {
    const response = await apiClient.get(
      `/brickbucket/product/global-search?search=${encodeURIComponent(
        search
      )}&page=${page}&page_size=${pageSize}`
    );
    return response.data || response;
  },
};